import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import { api } from '@/api';
import regexp from '@/common/regexp';
import { API_URL } from '@/dtos';

const useGetTransactionTypesByAccountIdQuery = (accountId?: string) => {
  const { isLoading, isSuccess, data } = useQuery<{ data?: string[] }>(
    [API_URL.ACTIVITIES_ACCOUNTS_TRANSACTION_TYPES_BY_ACCOUNT_ID(accountId || '')],
    () => api.get(API_URL.ACTIVITIES_ACCOUNTS_TRANSACTION_TYPES_BY_ACCOUNT_ID(accountId || '')),
    {
      enabled: Boolean(accountId),
    }
  );

  const transactionTypeOptions = useMemo(
    () =>
      data?.data?.map((item) => ({
        key: item,
        value: item,
        title: capitalize(item.replace(regexp.DASH_SYMBOL, ' '))
          .replace(' ee ', ' EE ')
          .replace('Hsa ', 'HSA ')
          .replace('Ach ', 'ACH '),
      })) || [],
    [data]
  );

  return {
    transactionTypes: data?.data || [],
    transactionTypeOptions,
    isLoading,
    isSuccess,
  };
};

export default useGetTransactionTypesByAccountIdQuery;
